import React from 'react';
import { AiFillDollarCircle } from 'react-icons/ai';

const BadgetInternet = ({ plan, costo, meses, total, descripcion }) => {
    return (
        <div>
            <div className="alert alert-success" role="alert">
                <div>
                    <span className="font-medium">
                <AiFillDollarCircle className="fs-3 mx-2" />
                        Cargo por servicio{' '}
                        <span className="bg-green text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                            ${costo} x {meses} = ${total}{' '}
                        </span>
                    </span>
                    {plan} <br /> {descripcion}
                </div>
            </div>
        </div>
    );
};

export default BadgetInternet;
